import { useEffect, useRef } from "react";
import { isFlozyMobileApp } from "../utils";

const IDLE_TIME = 5 * 60 * 1000; // 5 minutes in milliseconds

const useIdleTimeChecker = (): void => {
    const lastHiddenTime = useRef<number | null>(null);

    useEffect(() => {
        if (isFlozyMobileApp()) return;

        const handleVisibilityChange = (): void => {
            if (document.hidden) {
                lastHiddenTime.current = Date.now();
            } else {
                // User returned to tab
                if (lastHiddenTime.current) {
                    const idleDuration = Date.now() - lastHiddenTime.current;
                    if (idleDuration >= IDLE_TIME) {
                        window.location.reload();
                    }
                }
                lastHiddenTime.current = null;
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);
        return () => document.removeEventListener("visibilitychange", handleVisibilityChange);
    }, []);
};

export default useIdleTimeChecker;

